import React from 'react'

const Ssn = () => {
   return (
      <>
         <div className="section animated fadeIn">
            {/* TÍTULO DE LA SECCIÓN */}
            <div className="row mb-title center mb-4">
               <div className="col s12 m12 l12 x12">
                  <h4 className="light-blue-text text-accent-3 institutional-title" style={{ fontWeight: '600' }}>
                     SUPERINTENDENCIA DE SEGUROS DE LA NACIÓN
                  </h4>
               </div>
            </div>
            {/* TARJETA CONTENEDORA */}
            <div className="row justify-content-center">
               <div className="col s12 m12 l12">
                  <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#fafafa', padding: '30px' }}>
                     
                     {[
                        {
                           titulo: 'Resolución 76-E/2018',
                           url: 'http://www2.ssn.gob.ar/files/Archivos/A_Superintendencia/capacitacion_ssn/G_aut_reg_/Resol_2018_76.pdf'
                        },
                        {
                           titulo: 'Resolución 38052/2013',
                           url: 'http://servicios.infoleg.gob.ar/infolegInternet/anexos/220000-224999/224369/norma.htm'
                        },
                        {
                           titulo: 'Resolución 38477/2014',
                           url: 'http://servicios.infoleg.gob.ar/infolegInternet/anexos/230000-234999/232554/norma.htm'
                        },
                        {
                           titulo: 'Resolución 35550/11',
                           url: 'http://servicios.infoleg.gob.ar/infolegInternet/anexos/175000-179999/178890/norma.htm'
                        }
                     ].map((item, idx, arr) => (
                        <div 
                           key={idx} 
                           className="row valign-wrapper" 
                           style={{ 
                              display: 'flex', 
                              alignItems: 'center', 
                              marginBottom: idx === arr.length - 1 ? '0' : '18px', 
                              paddingBottom: idx === arr.length - 1 ? '0' : '18px', 
                              borderBottom: idx === arr.length - 1 ? 'none' : '1px solid #e0e0e0' 
                           }}
                        >
                           <div className="col s8 m9 l10">
                              <h6 className="grey-text text-darken-3" style={{ fontWeight: '600', margin: '0', fontSize: '1.05rem' }}>
                                 {item.titulo}
                              </h6>
                           </div>
                           <div className="col s4 m3 l2 center-align">
                              <a 
                                 href={item.url} 
                                 target="_blank" 
                                 rel="noopener noreferrer" 
                                 className="btn waves-effect waves-light light-blue accent-3 z-depth-0" 
                                 style={{ borderRadius: '4px', textTransform: 'none', width: '100%' }}
                              >
                                 Ver
                                 <i className="material-icons right" style={{ fontSize: '1.2rem', marginLeft: '5px' }}>visibility</i>
                              </a>
                           </div>
                        </div>
                     ))}
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}

export default Ssn